import { render, staticRenderFns } from "./AboutCurrencyPopup.vue?vue&type=template&id=8ddd779e&scoped=true&"
import script from "./AboutCurrencyPopup.vue?vue&type=script&lang=js&"
export * from "./AboutCurrencyPopup.vue?vue&type=script&lang=js&"
import style0 from "./AboutCurrencyPopup.vue?vue&type=style&index=0&id=8ddd779e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ddd779e",
  null
  
)

export default component.exports